import { storyblokEditable } from "@storyblok/react";
import { customRenderRichText } from "../utils/renderRichText";

const LargeImageCardItem = ({ blok }) => {
  return (
    <div
      {...storyblokEditable(blok)}
      className="
        flex flex-col 
        items-center text-center 
        md:items-start md:text-left
      "
    >
      {blok.image?.filename && (
        <img
          src={blok.image.filename}
          alt={blok.image.alt || blok.title}
          width={412}
          height={412}
          className="w-[412px] h-[412px] object-cover rounded-lg"
        />
      )}

      {/* Text width needs to be 412px to match the image constraints */}
      <div className="w-full max-w-[412px] mx-auto">
        <h3 className="text-xl font-semibold mt-4">{blok.title}</h3>

        <div className="text-gray-600 mt-2">
          {blok.description &&
            (typeof blok.description === "string"
              ? blok.description
              : customRenderRichText(blok.description))}
        </div>
      </div>
    </div>
  );
};

export default LargeImageCardItem;
